import { render } from "./AlertDeleteComponent.vue?vue&type=template&id=7222c25c&scoped=true&ts=true"
import script from "./AlertDeleteComponent.vue?vue&type=script&lang=ts"
export * from "./AlertDeleteComponent.vue?vue&type=script&lang=ts"

import "./AlertDeleteComponent.vue?vue&type=style&index=0&id=7222c25c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7222c25c"]])

export default __exports__